import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { checkBiometric } from "../../firestore";
import { useAuth } from "../../core/auth";
type Bio = {
  active?: boolean;
  biometrics: boolean;
  take_photo: boolean;
};
type BiometricContextType = {
  biometrics: Bio;
  setBiometrics: (value: Bio) => void;
};

const BiometricContext = createContext<BiometricContextType | undefined>(undefined);

export const BiometricProvider = ({ children }: { children: ReactNode }) => {
  const [biometrics, setBiometrics] = useState<any>(null);
  const { user } = useAuth();

  const getBiometric = async () => {
    const result = await checkBiometric(user?.companyId);
    setBiometrics(result?.data);
  };
  useEffect(() => {
    if (user?.companyId) getBiometric();
  }, [user?.companyId]);

  return (
    <BiometricContext.Provider value={{ biometrics, setBiometrics }}>
      {children}
    </BiometricContext.Provider>
  );
};

export const useBiometric = () => {
  const context = useContext(BiometricContext);
  if (!context) {
    throw new Error("useBiometric debe usarse dentro de un BiometricProvider");
  }
  return context;
};
